import { useQuery } from '@tanstack/react-query';
import { api } from 'modules/global/adapters';

export const useDashboardRequest = () => {
  return useQuery(['dashboard'], () => api.dashboard.getTransportOperatorDashboard());
};

export enum DashboardMetricType {
  OutGoingReleaseRight = 'outgoing-release-right',
  DeclinedReleaseRight = 'declined-release-right',
  CommercialReleases = 'commercial-releases',
  BlockedReleases = 'blocked-releases',
  ReleaseRightsWithoutPickup = 'release-rights-without-pickup',
}

export const useGetContainersByDashboardMetric = (
  metricType: DashboardMetricType,
  enabled: boolean
) => {
  return useQuery(
    ['containersByDashboardMetric', metricType],
    () => api.dashboard.getContainersByDashboardMetric({ metricType }),
    {
      enabled,
    }
  );
};
